/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Invoice_Company_PhoneInputs */

const vi_validation_invoice_company_phone = /** @type {(inputs: Validation_Invoice_Company_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập số điện thoại công ty`)
};

/**

* @param {Validation_Invoice_Company_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_invoice_company_phone = /** @type {((inputs?: Validation_Invoice_Company_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Invoice_Company_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_invoice_company_phone(inputs)
});